import React, { useState, useEffect } from "react";
import ReactECharts from "echarts-for-react";
import { Modal, Descriptions, Divider, Spin } from "antd";

export const EchartsRadar = ({ data }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [currentIndicator, setCurrentIndicator] = useState(null);
  const [loading, setLoading] = useState(false);

  const option = {
    title: {
      text: "综合素质评价雷达图",
      left: "center",
      subtext: "点击标签维度查看详细信息", 
       subtextStyle: {
      color: "#666",
      fontSize: 12,
      padding: [5, 0]
    }
    },
    tooltip: {
      show: false,
    },
    radar: {
      indicator: data.map((item) => ({
        name: item.name,
        max: 100,
        test: item.score,
      })),
      radius: "60%",
      splitNumber: 4,
      axisName: {
        color: "#1890ff",
        fontSize: 14,
        fontWeight: "bold",
        formatter: (name) => `{a|${name}}`,
        rich: {
          a: {
            color: "#1890ff",
            padding: [6, 12],
            borderRadius: 15,
            shadowColor: "rgba(24, 144, 255, 0.3)",
            shadowBlur: 8,
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            cursor: "pointer",
          },
        },
      },
      splitArea: {
        show: true,
        areaStyle: {
          color: ["rgba(255, 255, 255, 0.5)"],
        },
      },
      triggerEvent: true,
    },
    series: [
      {
        type: "radar",
        data: [
          {
            value: data.map((item) => Number(item.score).toFixed(3)),
            name: "综合评分", // 这里设置的是数据系列名称
            label: {
              show: true,
              formatter: (params) => Number(params.value).toFixed(3),
              position: "top",
              color: "#1890ff",
              fontSize: 14,
              fontWeight: "bold",
            },
          },
        ],
        areaStyle: {
          color: "rgba(24, 144, 255, 0.3)",
        },
        lineStyle: {
          width: 2,
          color: "#1890ff",
        },
        symbolSize: 8,
        emphasis: {
          lineStyle: {
            width: 4,
          },
          areaStyle: {
            color: "rgba(24, 144, 255, 0.5)",
          },
        },
      },
    ],
  };
  // 从富文本中提取实际名称
  const extractNameFromRichText = (richText) => {
    // 匹配 {a|...} 格式中的内容
    const match = richText.match(/\{a\|([^}]+)\}/);
    return match ? match[1] : richText;
  };
  const handleLabelClick = async (params) => {
    if (params.componentType === "radar" && params.targetType === "axisName") {
      const actualName = extractNameFromRichText(params.name);
      // console.log("点击的维度:", actualName);
      const clickedIndicator = await data.find(
        (item) => item.name === actualName
      );
      if (clickedIndicator) {
        setLoading(true);
        setCurrentIndicator(clickedIndicator);
        setModalVisible(true);
        setLoading(false);
      }
    }
  };
  return (
    <div>
      <ReactECharts
        option={option}
        style={{ height: "500px", width: "500px",margin:"0 auto" }}
        notMerge={true}
        lazyUpdate={true}
        onEvents={{
          click: handleLabelClick,
        }}
      />

      <Modal
        title={currentIndicator?.name || "指标详情"}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={800}
        height={600}
        style={{
          top: 90,
        }}
      >
        <Spin spinning={loading}>
          {currentIndicator && (
            <div>
              <Descriptions bordered size="middle">
                <Descriptions.Item label="单维度综合得分" span={3}>
                  <span
                    style={{
                      fontSize: 18,
                      color: "#1890ff",
                      fontWeight: "bold",
                    }}
                  >
                    {Number(currentIndicator.score).toFixed(3)} 分
                  </span>
                </Descriptions.Item>
              </Descriptions>

              <Divider orientation="left" style={{ marginTop: 24 }}>
                二级指标详情
              </Divider>

              <div style={{ maxHeight: 400, overflowY: "auto" }}>
                {currentIndicator.details.map((detail, index) => (
                  <div
                    key={index}
                    style={{
                      padding: "12px",
                      marginBottom: "12px",
                      border: "1px solid #f0f0f0",
                      borderRadius: "4px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "8px",
                      }}
                    >
                      <span style={{ fontWeight: "bold" }}>
                        {detail.indicator_name || `指标${index + 1}`}
                      </span>
                      <span
                        style={{
                          color:
                            detail.score >= 80
                              ? "#52c41a"
                              : detail.score >= 60
                              ? "#faad14"
                              : "#ff4d4f",
                          fontWeight: "bold",
                        }}
                      >
                        {detail.score !== null ? `${detail.score}分` : "未评价"}
                      </span>
                    </div>
                    <Descriptions size="small" column={1}>
                      {detail.comment && (
                        <Descriptions.Item label="评语">
                          {detail.comment}
                        </Descriptions.Item>
                      )}
                    </Descriptions>
                  </div>
                ))}
              </div>
            </div>
          )}
        </Spin>
      </Modal>
    </div>
  );
};
